import React from "react";
import { PageHeader } from "./PageHeader";

export const ProgramCommittee = props => {
  var ulSize = {
    fontSize: '18px'
  };
  return (
    <React.Fragment>
      <PageHeader title="Komitety" />
      <div className="content-wrapper">
        <div className="main-content program">
          <h2>Komitet Programowy</h2>
          <ul style={ulSize}>
            <li>Prof. dr hab. Józef Spałek, Uniwersytet Jagielloński - <i>Przewodniczący Komitetu Programowego</i></li>
            <li>Prof. dr hab. Marek Cieplak, Instytut Fizyki Polskiej Akademii Nauk</li>
            <li>Prof. dr hab. Ewa Gudowska-Nowak, Uniwersytet Jagielloński</li>
            <li>Prof. dr hab. Zbigniew Kąkol, Akademia Górniczo-Hutnicza</li>
            <li>Prof. dr hab. Adam Maj, Instytut Fizyki Jądrowej im. Prof. H.Niewodniczańskiego Polskiej Akademii Nauk</li>
            <li>Prof. dr hab. Roman Płaneta, Uniwersytet Jagielloński</li>
            <li>Prof. dr hab. Arkadiusz Wójs, Politechnika Wrocławska</li>
            <li>Prof. dr hab. Andrzej Wysmołek, Uniwersytet Warszawski</li>
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
};

ProgramCommittee.propTypes = {};
